<template>
  <div v-if="config" :class="{'is-flex-grow-1': isFullWidth}">
    <div v-if="!attachement" class="columns is-vcentered imageIcon">
      <div class="column is-cursor-pointer is-12">
        <uploader
          v-if="!readOnly"
          @added="addFile"
          @filePrevented="filePrevented"
          class="upload-box-ligne-commande has-background-light is-cursor-pointer
            is-fullwidth is-height-inherit"
          :extensions="/\.(gif|jpe?g|png|webp|bmp)$/i"
          accept="image/*"
          :name="`uploader-${this.id}`"
          :size="maxSize">
          <b-icon
            icon="plus-circle"
            size="is-small"
            class="is-cursor-pointer logo-plus-small"
            type="is-grey-lighter">
          </b-icon>
        </uploader>
        <img v-else :src="url" class="imageIcon">
      </div>
    </div>
    <div v-else class="is-position-relative">
      <b-icon
        v-if="!readOnly"
        class="upload-close-btn has-background-background"
        icon="close-circle"
        type="is-grey-lighter"
        @click.native="popUpPrevention = true"
      />
      <div class="is-inline">
        <router-link :to="{
                name: 'detail-image-produit',
                params: {
                  id: id,
                  libelle: libelleImage },
                }"
                target="_blank"
                :class="{'text-access-no-permission' : !checkPermissions(permissions)}">
          <b-tooltip v-if="withToolTip" size="is-large" position="is-right" type="is-select">
            <img :src="url" class="imageIcon">
            <template v-slot:content>
              <img :src="url" class="imageContent">
            </template>
          </b-tooltip>
          <img v-else :src="url"
            ref="cLogo"
            @load="getImageDimensions"
            :class="{
              'image': isFullWidth,
              'logo-img': isFullWidth,
              'is-cursor-pointer' : isFullWidth,
              'is-fullwidth' : isFullWidth && isImagePaysage,
              'imageIcon' : !isFullWidth,
            }"
           >
        </router-link>
      </div>
    </div>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up-prevention :mess-header="$t('general.popUpSuppresionPjImage.title.image')"
                         :cancel="$t('general.button.cancel')"
                         :validate="$t('general.button.next')"
                         @no="popUpPrevention=false"
                         @yes="deleteFile">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpResizeLogo" id="modal_cropper">
      <resize-img :data-file="file" @img-resize="addResizedFile">
      </resize-img>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { remove, getConfiguration, getAllByElementId } from '@/api/pieceJointes/index';
import { insertPieceJointe } from '@/services/piecesJointes/savePiecesJointes';
import messageErreur from '@/services/general/messageErreur';
import messageInformation from '@/services/general/messageInformation';
import { PIECE_JOINTE_TYPE_LOGO } from '@/configuration/general/pieceJointeConf';
import { TAILLE_PJ_LIMITE } from '@/configuration/piecesJointes';
import uploader from '@/components/general/uploader';
import ResizeImg from '@/components/general/resize-img';
import popUpPrevention from '@/components/general/popUpPrevention';

const Permissions = createNamespacedHelpers('permissions');
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    context: {
      type: String,
      required: true,
    },
    libelleImage: {
      type: String,
      required: false,
      default: 'Image',
    },
    permissions: {
      type: Object,
      required: true,
    },
    resizeFile: {
      type: Boolean,
      required: false,
      default: true,
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    withToolTip: {
      type: Boolean,
      required: false,
      default: true,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file: null,
      config: null,
      attachement: null,
      popUpResizeLogo: false,
      popUpPrevention: false,
      imageWidth: null,
      imageHeight: null,
    };
  },
  components: {
    uploader,
    ResizeImg,
    popUpPrevention,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    maxSize() {
      return this.config.maxSize ?? TAILLE_PJ_LIMITE;
    },
    url() {
      return this.attachement?.cheminMin || this.attachement?.chemin || '/static/img/default-placeholder.png';
    },
    isImagePaysage() {
      if (!this.imageHeight || !this.imageWidth) {
        return false;
      }
      return (this.imageWidth / this.imageHeight) >= 2;
    },
  },
  methods: {
    async addFile(file) {
      this.file = file;
      if (!this.resizeFile) {
        await this.addResizedFile(file);
        return;
      }
      this.popUpResizeLogo = true;
    },
    async deleteFile() {
      const loadingComponent = this.$buefy.loading.open();
      if (!this.attachement?.id) return;
      try {
        await remove(this.attachement.id);
        this.attachement = null;
        this.popUpPrevention = false;
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.i18n);
        throw e;
      }
    },
    async addResizedFile(file) {
      if (!file) return;
      const loadingComponent = this.$buefy.loading.open();
      this.file = file;
      const formatedFile = {
        ...file,
        typeId: file.groupType,
        nom: file.name,
        placeType: PIECE_JOINTE_TYPE_LOGO,
      };
      try {
        await insertPieceJointe([formatedFile], this.id, this.module);
        this.popUpResizeLogo = false;
        await this.loadAttachement();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async loadAttachement() {
      const attachementLoaded = (await getAllByElementId(this.id)).data.result.items
        .find((image) => image.placeType === 'Logo');
      this.attachement = attachementLoaded ?? null;
    },
    filePrevented(error) {
      messageInformation(error.message, 'is-danger');
    },
    getImageDimensions() {
      const image = this.$refs.cLogo;
      const width = image.naturalWidth;
      const height = image.naturalHeight;
      this.imageWidth = width;
      this.imageHeight = height;
    },
  },
  async mounted() {
    await this.loadAttachement();
    this.config = (await getConfiguration()).data.result;
  },
};
</script>

<style>

</style>
